import { Project } from '@/app/api';
import { mixpanelTrack } from '@/app/hooks/useAnalytics/mixpanel-track';
import { MixpanelEvent } from '@/app/hooks/useAnalytics/types';
import { envs } from '@/app/utils/envs';

type PushProjectDetailSharedEventParams = {
  project: Project;
  areStatisticsCookiesAllowed: boolean;
  shareMethod: ShareMethod;
  userId: string | undefined;
};

export const pushProjectDetailSharedEvent = (params: PushProjectDetailSharedEventParams) => {
  if (!params.areStatisticsCookiesAllowed) {
    if (envs.isAnalyticInDebugMode) {
      console.log('Skiping share event, because statistics cookies are not allowed');
    }
    return;
  }

  publicMixpanelEvent(params);
};

export enum ShareMethod {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  WHATSAPP = 'whatsapp',
  GENERAL = 'general',
  PRINT = 'print',
  INSTAGRAM = 'instagram',
  X = 'twitter',
}

const publicMixpanelEvent = ({ project, shareMethod, userId }: PushProjectDetailSharedEventParams) => {
  mixpanelTrack(MixpanelEvent.Shared, {
    project_id: project.numericId,
    project_name: project.content.currentName,
    project_mode: project.settings.modeGroup,
    project_main_category: project.settings.taxonomy.mainCategory?.name,
    project_categories: project.settings.taxonomy.categories.map((item) => item.name),
    method: shareMethod,
    topic: project.settings.taxonomy.topic?.name,
    $user_id: userId,
  });
};
